/* eslint-disable no-unused-vars,@typescript-eslint/no-unused-vars */
import { DropEventDelegate } from './interface/drop-event-delegate';
import { dispatchCustomEvent } from '@src/js/utils';

/**
 * 文件拖拽
 */
export default class DropEventHandler {
    private dropDelegate: DropEventDelegate;

    public constructor(dropDelegate: DropEventDelegate) {
        this.dropDelegate = dropDelegate;
    }

    public registerDragEvent() {
        document.addEventListener('drop', this.handlerDrop);
        document.addEventListener('dragover', this.handlerDragover);
        document.addEventListener('dragleave', this.handlerDragLeave);
    }

    public unRegisterDragEvent() {
        document.removeEventListener('drop', this.handlerDrop);
        document.removeEventListener('dragover', this.handlerDragover);
        document.removeEventListener('dragleave', this.handlerDragLeave);
    }

    private handlerDrop = (e) => {
        this.handlerCustom(e, () => dispatchCustomEvent('drop', window, e));
    };

    private handlerDragover = (e) => {
        this.handlerCustom(e, () => dispatchCustomEvent('dragover', window, e));
    };

    private handlerDragLeave = (e) => {
        this.handlerCustom(e, () => dispatchCustomEvent('dragleave', window, e));
    };

    private async handlerCustom(e, customer = () => {
    }) {
        customer();
        const { copyPasteImageService } = this.dropDelegate.getServices();
        const module = await copyPasteImageService?.promise();
        const { preventDefaultIfTypeIsFile } = module || { };
        preventDefaultIfTypeIsFile?.(e);
    }
}
